import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Shared lead form used by Contact, Valuation, ListWithUs and PropertyDetail
export default function LeadForm({
  source = "website", interest, listingId, testIdPrefix = "lead",
  submitLabel = "Send enquiry", messagePlaceholder = "Tell us how we can help…",
  theme = "dark", // "dark" (public) | "light" (admin)
}) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads", { ...form, source, interest, listing_id: listingId });
      setDone(true);
      toast.success("Enquiry received. An advisor will be in touch shortly.");
    } catch {
      toast.error("Please check your details and try again.");
    } finally { setBusy(false); }
  }

  const dark = theme === "dark";
  const inputCls = dark
    ? "w-full bg-white border border-neutral-300 px-4 py-3 text-sm text-[#050d19] placeholder:text-neutral-400 focus:outline-none focus:border-[#001588]"
    : "w-full border border-gray-300 px-4 py-3 text-sm text-[#050d19] placeholder:text-neutral-400 focus:outline-none focus:border-[#050d19]";

  if (done) {
    return (
      <div className={dark ? "border border-[#001588]/30 p-6 text-neutral-800" : "border border-gray-300 p-6 text-gray-800"}
           data-testid={`${testIdPrefix}-success`}>
        Message received. An advisor will reach out shortly.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${testIdPrefix}-form`}>
      {["name", "email", "phone"].map((k) => (
        <input
          key={k} required type={k === "email" ? "email" : "text"}
          value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
          placeholder={k.charAt(0).toUpperCase() + k.slice(1)}
          className={inputCls}
          data-testid={`${testIdPrefix}-${k}`}
        />
      ))}
      <textarea
        value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows="3"
        placeholder={messagePlaceholder}
        className={inputCls}
        data-testid={`${testIdPrefix}-message`}
      />
      <button
        type="submit" disabled={busy}
        className={dark
          ? "w-full py-3 bg-[#001588] text-white tracking-wide hover:bg-black transition-colors disabled:opacity-50"
          : "w-full py-3 bg-[#001588] text-white tracking-wide hover:bg-black transition-colors disabled:opacity-50"}
        data-testid={`${testIdPrefix}-submit`}
      >
        {busy ? "Sending…" : submitLabel}
      </button>
    </form>
  );
}
